<template>
  <footer class="block-footer footer" :class="[device_platform]">
    <div class="footer__container">
      <p>© 2023. Ауди Центр Север. Все права защищены</p>

      <br><br>23 мая Ауди Россия подвела итоги конкурса на звание лучшего дилерского центра марки с четырьмя кольцами в России по итогам работы в 2021 году.
      <br>В рамках конкурса оценивалась деятельность всех официальных дилерских центров Audi на территории России.
      <br>Целью проекта является оценка дилеров по комплексному показателю, включающему пять основных направлений: продажи новых автомобилей, продажи автомобилей с пробегом, архитектура дилерского центра, маркетинговая активность и послепродажное обслуживание.


      <br><br>АО «РОЛЬФ»
      <br>ИНН 5047254063
      <br>ОГРН: 1215000076279
      <p class="footer__links-title">
        Мобильное приложение Ауди Центра Север<br />
        Ваш личный помощник
      </p>
      <div class="footer__social-links">
        <a
          class="footer__link"
          href="https://play.google.com/store/apps/details?id=ru.rolf.rolf&referrer=utm_source%3Dsite%26utm_medium%3Drolf_ru"
          target="_blank"
        >
          <img src="../images/utils/google-play.svg" alt="Google Play" />
        </a>
        <a
          class="footer__link"
          href="https://itunes.apple.com/app/apple-store/id1407250313?mt=8"
          target="_blank"
        >
          <img src="../images/utils/app-store.svg" alt="App Store"
        /></a>
      </div>
    </div>
  </footer>
</template>

<script>
import Mixin from "../common/mixin";

export default {
  name: "block-footer",
  mixins: [Mixin],
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.footer {
  width: 100%;
  padding-top: 30px;
  color: #000;
  font-size: 15px;
  background-color: #fff;

  &__container {
    max-width: 1150px;
    width: 100%;
    margin: 0 auto;
    padding: 0 20px;
  }

  &__link {
    margin-right: 8px;
  }

  &__links-title {
    margin: 27px 0 30px 0;
  }
}
</style>
